/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 17.04.13
 * Time: 11:01
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";
import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";

/**
 * Visual component to show a quest dialog if offer reach offer quest started state
 */
export class OfferDescriptionVisualQuestDialog implements IOfferDescriptionVisualParameter {
    private _dialogName: string;
    private _autoShow: boolean;

    constructor(dialogName: string, autoShow: boolean = true) {
        this._dialogName = dialogName;
        this._autoShow = autoShow;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_QUEST_DIALOG;
    }

    public parseFromObjectParam(params: any): void {
        this._dialogName = params.DN;

        if (params.AS != null) {
            this._autoShow = params.AS;
        }
        else {
            this._autoShow = true;
        }
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // show quest dialog with registered dialog name
        if (this._autoShow) {
            // OVERRIDE TO EXECUTE DIALOGHANDLER
            //BasicDialogHandler.getInstance().registerDialogs(_dialogName, new BasicPrivateOfferDialogProperties(offerVO));
        }
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return state === PrivateOfferStateEnum.QUEST_STARTED;
    }

    public get autoShow(): boolean {
        return this._autoShow;
    }

    public get dialogName(): string {
        return this._dialogName;
    }

    public dispose(): void {
        this._dialogName = null;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_QUEST_DIALOG";
    }
}
